// Angular imports
import { Pipe, PipeTransform } from '@angular/core';

// Import sanitize-html
import sanitizeHtml from 'sanitize-html';

// Import types
import { CalculationLineApi } from '../types';
import { LineTag } from '../tables';

// Constants
import { LINE_TAGS, LINE_COMMENT_TYPE_CONFIGS, CommentType } from '../constants';

@Pipe({
    name: 'lineTags',
    standalone: false
})
export class LineTagsPipe implements PipeTransform {
    public transform(value: CalculationLineApi): LineTag[] {
        const commentType: CommentType | undefined = LINE_COMMENT_TYPE_CONFIGS.find(t => t.id === value.comment?.type);
        const commentText = value.comment?.text;

        return [
            ...(commentType ? [{
                ...commentType,
                text: commentText ? sanitizeHtml(commentText, { allowedTags: [], allowedAttributes: {} }) : commentType.name
            }] : []),
            ...(value.unit === 'sptN' ? [LINE_TAGS['net_spt']] : []),
            ...(value.unit === 'spt' ? [LINE_TAGS['gross_spt']] : []),
        ];
    }
}
